






















































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import T from '../../lang';
import * as ui from '../../ui';
import { types } from '../../api_types';

import omegaup_Markdown from '../Markdown.vue';
import omegaup_RadioSwitch from '../RadioSwitch.vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import {
  faChalkboardTeacher,
  faFileAlt,
  faListAlt,
} from '@fortawesome/free-solid-svg-icons';
library.add(faChalkboardTeacher, faFileAlt, faListAlt);

const levels = {
  introductory: T.courseLevelIntroductory,
  intermediate: T.courseLevelIntermediate,
  advanced: T.courseLevelAdvanced,
};

interface Statement {
  [name: string]: {
    gitObjectId?: string;
    markdown?: string;
    statementType?: string;
  };
}

@Component({
  components: {
    FontAwesomeIcon,
    'omegaup-markdown': omegaup_Markdown,
    'omegaup-radio-switch': omegaup_RadioSwitch,
  },
})
export default class CourseIntro extends Vue {
  @Prop() course!: types.CourseDetails;
  @Prop() needsBasicInformation!: boolean;
  @Prop() shouldShowAcceptTeacher!: boolean;
  @Prop() statements!: Statement;
  @Prop({ default: null }) userRegistrationRequested!: boolean;
  @Prop({ default: null }) userRegistrationAnswered!: boolean;
  @Prop({ default: null }) userRegistrationAccepted!: boolean;
  @Prop() loggedIn!: boolean;

  T = T;
  ui = ui;
  levels = levels;

  shareUserInformation = false;
  acceptTeacher = false;
  window = window;

  get isButtonDisabled(): boolean {
    return (
      this.needsBasicInformation ||
      (this.course.requests_user_information === 'required' &&
        !this.shareUserInformation)
    );
  }

  get displayCoursePrivacyBullets(): boolean {
    return (
      (this.userRegistrationAccepted ||
        this.userRegistrationRequested === false) &&
      (this.needsBasicInformation ||
        this.course.requests_user_information != 'no' ||
        this.shouldShowAcceptTeacher)
    );
  }

  onSubmit(): void {
    this.$emit('submit', {
      shareUserInformation: this.shareUserInformation,
      acceptTeacher: this.acceptTeacher,
    });
  }

  onRequestAccess(): void {
    this.$emit('request-access-course', {
      shareUserInformation: this.shareUserInformation,
      acceptTeacher: this.acceptTeacher,
    });
  }
}
